import { Component, EventEmitter, OnDestroy, Output, ViewChild } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { Subscription } from 'rxjs'
import { SeFeModalButton, SeFeModalComponent, SeFeModalFooterComponent } from 'se-fe-modal'
import { Persona } from '../../models'
import { PersonaService } from '../../services'

@Component({
  selector: 'app-profile-unclaim-modal',
  templateUrl: './profile-unclaim-modal.component.html'
})
export class ProfileUnclaimModalComponent implements OnDestroy {
  @Output() public successfulDestroy: EventEmitter<number> = new EventEmitter<number>()
  @ViewChild('modal') public modal: SeFeModalComponent
  @ViewChild('modalFooter') public modalFooter: SeFeModalFooterComponent

  public failure = false
  public options: SeFeModalButton[]
  public persona: Persona
  public errorMessage = ''

  private _subscriptions: Subscription[] = []

  constructor(private translateService: TranslateService,
              private personaService: PersonaService) {
    // noop
  }

  public ngOnDestroy(): void {
    this._subscriptions.forEach(subscription => subscription.unsubscribe())
    this._subscriptions.length = 0
  }

  public open(persona: Persona): void {
    this.failure = false
    this.persona = persona
    this.options = [
      {
        label: this.translateService.instant('MODAL.cancel'),
        action: () => this.modal.close()
      },
      {
        primary: true,
        label: this.translateService.instant(
          'UNCLAIM_PROFILE_MODAL.save',
          { name: this.persona.first_name }),
        action: () => this.save()
      }
    ]
    this.modal.open(null)
  }

  public save(): void {
    this.failure = false
    this._subscriptions.push(this.personaService.destroy(this.persona.id)
      .subscribe(_ => {
        this.successfulDestroy.emit(this.persona.id)
        this.modal.close()
      },
      err => {
        const resError = err.error?.error?.messages?.pop()
        this.errorMessage = resError || this.translateService.instant('UNCLAIM_PROFILE_MODAL.ERRORS.unclaim_failed')
        this.failure = true
        this.modalFooter.cancelSpinner()
      }))
  }
}
